import { EPermissoes } from '@/enums/ePermissoes';

export default [
  {
    description: 'Configuração de Tipo Fornecimento',
    path: 'tipo-fornecimento/form',
    name: 'gestaotipofornecimentoform',
    component: () => import('@/views/utilidade/tipo-fornecimento/Index.vue'),
    meta: {
      permissions: [EPermissoes.ConfiguracaoCliente]
    },
    goesToMenu: true
  }
];
